import { CountryModel } from 'services/EpdClient';
import { useOptions } from './useOptions';
import CompanyService from 'services/CompanyService';
import { GLOBAL_OPTION, Role } from 'constants/constants';

export const useAllCountriesLookup = () =>
  useOptions<CountryModel>({ queryKey: ['countriesLookup'], fetchFn: () => CompanyService.getCountries() });

// Verifier marketplace countries
export const useVerifierMarketplaceCountriesLookup = () =>
  useOptions<CountryModel>({
    queryKey: ['countries', Role.EPDVerifier],
    fetchFn: () => CompanyService.getCountries(Role.EPDVerifier),
  });

export const useVerifierMarketplaceCountriesLookupWithGlobal = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useOptions<CountryModel>({
    queryKey: ['countries', Role.EPDVerifier, 'marketplace', 'withGlobal'],
    fetchFn: () => CompanyService.getCountries(Role.EPDVerifier),
    mapperFn: (country) => ({
      value: country.id || '',
      label: country.name || '',
    }),
    options: {
      enabled,
      select: (data) => [GLOBAL_OPTION, ...data],
    },
  });

// EPD developer/practitioner marketplace countries
export const usePractitionerMarketplaceCountriesLookup = () =>
  useOptions<CountryModel>({
    queryKey: ['countries', Role.EPDDeveloper],
    fetchFn: () => CompanyService.getCountries(Role.EPDDeveloper),
  });
